import { PlaceUserDto, PublicServerPlaceEvent } from 'gleblu-socket-api';
import { Action } from 'redux-act';
import { put, takeEvery } from 'redux-saga/effects';

import {
  employeeRegistrationCompleted,
  employeeRegistrationFailed,
  registerEmployee,
  RegisterEmployeePayload,
} from '../../actions/registration/registerEmployee';
import getPublicResponse from '../getPublicResponse';

function* registerEmployeeSaga({ payload }: Action<RegisterEmployeePayload>) {
  const { token, placeUser, password } = payload;
  const placeUserDto: PlaceUserDto = placeUser;
  const socketPayload = { token, placeUser: placeUserDto, password };
  const response = yield getPublicResponse(PublicServerPlaceEvent.employeeRegistration, socketPayload);
  const { error, errorType, placeUser: updatedPlaceUser } = response;
  if (error || errorType) {
    const action = employeeRegistrationFailed({ token, errorType });
    yield put(action);
  } else {
    const action = employeeRegistrationCompleted({ token, placeUser: updatedPlaceUser });
    yield put(action);
  }
}

export default function* watchRegisterEmployeeSaga() {
  yield takeEvery(registerEmployee, registerEmployeeSaga);
}
